export default "__VITE_ASSET__CoKfXwAg__"